// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"36d2d516","221":"19f52752","309":"9bd95852","383":"090224b0","509":"8b40d622","818":"cdca9a81","869":"4c0b454f"}[chunkId] + ".chunk.js";
};